export default "__VITE_ASSET__DEdzOeEM__"